import { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { getProductPrice } from '../../utils/pricing';
import { usePermissions } from '../../hooks/usePermissions';
import { useAuth } from '../../context/AuthContext';
import ProductForm from './ProductForm';

export default function ProductTable() {
    const { products, deleteProduct } = useAppContext();
    const { userProfile } = useAuth();
    const { getProductLimit } = usePermissions();

    const [editingProduct, setEditingProduct] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);

    const handleEdit = (product) => {
        setEditingProduct(product);
        setShowEditModal(true);
    };

    const handleEditComplete = () => {
        setEditingProduct(null);
        setShowEditModal(false);
    };

    const handleDelete = async (id, name) => {
        if (window.confirm(`Tem certeza que deseja excluir o produto "${name}"?`)) {
            try {
                await deleteProduct(id);
            } catch (err) {
                alert('Erro ao excluir produto');
            }
        }
    };

    if (!products.length) {
        return (
            <div className="alert alert-light border">
                Nenhum produto cadastrado ainda. Use o formulário ao lado para adicionar.
            </div>
        );
    }

    const currentPlan = userProfile?.plan || 'basico';
    const productLimit = getProductLimit();
    const showLimitBadge = currentPlan === 'basico';

    return (
        <>
            <div className="card shadow-sm">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h2 className="h5 mb-0">Lista de produtos ({products.length})</h2>
                        {showLimitBadge && (
                            <span className={`badge ${products.length >= productLimit ? 'bg-danger' : products.length >= productLimit * 0.8 ? 'bg-warning' : 'bg-info'}`}>
                                Plano Básico: {products.length}/{productLimit}
                            </span>
                        )}
                    </div>
                    <div className="table-responsive">
                        <table className="table table-hover align-middle">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Tipo</th>
                                    <th>Preços</th>
                                    <th className="text-end">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {products.map((p) => {
                                    const unitPrice = getProductPrice(p);
                                    const packagePrice = p.sellByPackage ? unitPrice * (p.packageSize || 10) : null;
                                    const centoPrice = p.sellByCento ? p.centoPrice : null;

                                    return (
                                        <tr key={p.id}>
                                            <td>
                                                <div className="fw-semibold">{p.name}</div>
                                                <div className="small text-muted">
                                                    Custo: R$ {p.unitCost.toFixed(2)} | Margem: {p.marginPercent}%
                                                </div>
                                            </td>
                                            <td>
                                                <span className="badge bg-secondary">
                                                    {p.type === 'artesanal' ? 'Artesanal' : 'Congelado'}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="small">
                                                    <div className="fw-semibold">Unitário: R$ {unitPrice.toFixed(2)}</div>
                                                    {packagePrice && (
                                                        <div className="text-success">
                                                            Bandeja ({p.packageSize} un.): R$ {packagePrice.toFixed(2)}
                                                        </div>
                                                    )}
                                                    {centoPrice && (
                                                        <div className="text-success">
                                                            Cento (100 un.): R$ {centoPrice.toFixed(2)}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="text-end">
                                                <button
                                                    className="btn btn-sm btn-outline-primary me-1"
                                                    onClick={() => handleEdit(p)}
                                                    title="Editar"
                                                >
                                                    <i className="bi bi-pencil"></i>
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleDelete(p.id, p.name)}
                                                    title="Excluir"
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Modal de edição */}
            {showEditModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-body p-0">
                                <ProductForm
                                    editingProduct={editingProduct}
                                    onEditComplete={handleEditComplete}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
